import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { ReasonOfExtensionInsertService } from '../../service/reason-of-extension-insert/reason-of-extension-insert.service';

@Component({
	selector: 'app-reason-of-extension-insert',
	templateUrl: './reason-of-extension-insert.component.html',
	providers: [
		ReasonOfExtensionInsertService,
		HttpModule
	]
})
export class ReasonOfExtensionInsertComponent implements OnInit {

	private token;
	reasonOfExtension: FormGroup;
	Nome: string = "";
	statusReasonOfExtension: boolean;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private reasonOfExtensionInsertService: ReasonOfExtensionInsertService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.reasonOfExtension = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addReasonOfExtension(value: any) {
		this.reasonOfExtensionInsertService.insertCompanyType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/motivo-de-prorrogacao');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/motivo-de-prorrogacao');
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-extension/component/reason-of-extension-insert/reason-of-extension-insert.component.ts